const useThreshold = (steps: number = 10) => {
  var thresholds = []

  for (var i = 1.0; i <= steps; i++) {
    var ratio = i / steps
    thresholds.push(ratio)
  }

  thresholds.push(0)
  return thresholds
}

export default useThreshold
